import { render, staticRenderFns } from "./InboxName.vue?vue&type=template&id=5e71bfe9&"
import script from "./InboxName.vue?vue&type=script&lang=js&"
export * from "./InboxName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e71bfe9')) {
      api.createRecord('5e71bfe9', component.options)
    } else {
      api.reload('5e71bfe9', component.options)
    }
    module.hot.accept("./InboxName.vue?vue&type=template&id=5e71bfe9&", function () {
      api.rerender('5e71bfe9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/InboxName.vue"
export default component.exports